/**
 * Si la ventana cumple una media query (`(max-width:860px)`), al dia: cambia
 * sola al girar el telefono o achicar la ventana.
 *
 * Es para lo que el CSS no alcanza: cuando lo que cambia con el ancho no es
 * el aspecto sino el marcado (el menu del catalogo es pestanas en escritorio y
 * acordeon en el telefono).
 */
import { useCallback, useSyncExternalStore } from 'react';

export function useConsultaMedios(consulta: string): boolean {
  const suscribir = useCallback(
    (avisar: () => void) => {
      const lista = window.matchMedia(consulta);
      lista.addEventListener('change', avisar);
      return () => {
        lista.removeEventListener('change', avisar);
      };
    },
    [consulta],
  );

  return useSyncExternalStore(suscribir, () => window.matchMedia(consulta).matches);
}
